import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { FormattedHTMLMessage } from '@99designs/common/i18n';
import { Color } from 'projects/consts';
import { redirectLaunchedStructuredBrief, redirectTo, routes } from 'projects/routes';
import React from 'react';
import ColorComponent from './Color';
import { DrawerOverlay } from './DrawerOverlay';

export const enum LaunchState {
    InProgress = 'InProgress',
    Success = 'Success',
    Error = 'Error',
}

interface Props {
    state: LaunchState;
    brief: {
        designers: { displayName: string }[];
        foreignKeys: number[];
    };
    showing: boolean;
}

const SquarespaceLaunchModal = ({ state, brief, showing }: Props) => {
    const isSingleDesigner = brief.designers.length == 1;
    return (
        <DrawerOverlay showing={showing} variations={['center']}>
            {state == LaunchState.Success && (
                <>
                    <ColorComponent color={Color.forrestLyf}>
                        <Icon type={'tick-3'} variations={['4x']} />
                    </ColorComponent>
                    <div className="heading heading--with-divider heading--h3">
                        {isSingleDesigner ? (
                            <FormattedHTMLMessage
                                message={__('Done!<br />We’ve sent your invite to {displayName}.')}
                                values={{ displayName: brief.designers[0].displayName }}
                            />
                        ) : (
                            <FormattedHTMLMessage
                                message={__(
                                    'Done!<br />We’ve sent your invite to {number} Squarespace designers'
                                )}
                                values={{
                                    number: brief.foreignKeys.length,
                                }}
                            />
                        )}
                    </div>

                    <p className="paragraph">
                        {isSingleDesigner ? (
                            __('You’ll receive a response and/or quote within 24 hours.')
                        ) : (
                            <FormattedHTMLMessage
                                message={__(
                                    'You’ll start to receive responses and/or quotes from designers within 24 hours. You can keep an eye on progress from inside of <strong>Your Work.</strong>'
                                )}
                            />
                        )}
                    </p>
                    <Button
                        onClick={() => redirectLaunchedStructuredBrief(brief)}
                        variations={['primary', 'jumbo']}
                    >
                        {__('Continue')}
                    </Button>
                </>
            )}
            {state == LaunchState.Error && (
                <>
                    <ColorComponent color={Color.risingSun}>
                        <Icon type={'exclamation-point-2'} variations={['4x']} />
                    </ColorComponent>
                    <div className="heading heading--with-divider heading--h3">
                        <FormattedHTMLMessage
                            message={__('Uh oh!<br />Something has gone wrong')}
                        />
                    </div>

                    <p className="paragraph">
                        {__(
                            'Please try again in a couple of minutes or reach out to our friendly Support Team for help.'
                        )}
                    </p>
                    <ColorComponent color={Color.risingSun}>
                        <Button
                            onClick={() => redirectTo(routes.support())}
                            variations={['primary', 'jumbo', 'chameleon']}
                        >
                            {__('Contact support')}
                        </Button>
                    </ColorComponent>
                </>
            )}
        </DrawerOverlay>
    );
};

export default SquarespaceLaunchModal;
